import { IDunningStepCreateSchema } from '@monetize/types/app';

const convertEmailStringToArray = (
  value: IDunningStepCreateSchema['internalCCEmails'],
) => {
  if (!value) {
    return null;
  }

  const emails = (Array.isArray(value) ? value : value.split(','))
    .map((email) => email.trim())
    .filter(Boolean);

  return emails.length > 0 ? emails : null;
};

export const convertDunningRequestFromResponse = (
  step: IDunningStepCreateSchema,
): IDunningStepCreateSchema => ({
  ...step,
  internalCCEmails: convertEmailStringToArray(step.internalCCEmails),
  internalBCCEmails: convertEmailStringToArray(step.internalBCCEmails),
});
